const helper = {
    toastSubmitResult: (success, $toast) => {
        if (success) {
            $toast.add({
                severity: "success",
                summary: `اطلاعات با موفقیت ذخیره شد!`,
                life: 3000

            });
        } else {
            $toast.add({
                severity: "error",
                summary: `اشکال در ذخیره‌سازی اطلاعات`,
                life: 3000

            });
        }
    },
    toastDeleteResult: (success, $toast) => {
        if (success) {
            $toast.add({
                severity: "success",
                summary: `آیتم‌های مورد نظر با موفقیت حذف شد!`,
                life: 3000
            });
        } else {
            $toast.add({
                severity: "error",
                summary: `اشکال در حذف آیتم(های) مورد نظر!`,
                life: 3000
            });
        }
    },
    toCamelCase: (str) => {
        return str.charAt(0).toLowerCase() + str.slice(1)
    },
    toPascalCase: (str) => {
        return str.charAt(0).toUpperCase() + str.slice(1);
    }
}

export default helper